<div class="lead-filter">
    <div class="lead-filter-quick">  
        <div class="lead-filter-quick-block lead-filter-quick-block-multiselect">
            <!-- Usuários Responsáveis -->
            <div class="lead-filter-quick-block-multiselect-item">
                <sgt-usuario-multiselect
                    [(idsUsuarios)]="filter.idsUsuariosResponsaveis"
                    (idsUsuariosChange)="onChangeUsuariosResponsaveis()"
                    defaultTitle="Responsáveis"
                    [disabled]="!isFilterInitialized">
                </sgt-usuario-multiselect>
            </div>
            <!-- Origens -->
            <div class="lead-filter-quick-block-multiselect-item">
                <sgt-origem-multiselect
                    [(origens)]="filter.origens"
                    (origensChange)="onChangeOrigensLead()"
                    defaultTitle="Origens"
                    [disabled]="!isFilterInitialized">
                </sgt-origem-multiselect>
            </div>                                     
            <!-- Classificações -->
            <div class="lead-filter-quick-block-multiselect-item">
                <sgt-classificacao-tipo-multiselect
                    [(idsClassificacoes)]="filter.idsClassificacoes"
                    (idsClassificacoesChange)="onChangeClassificacoes()"
                    [(nullOption)]="filter.classificacaoNull"
                    [showNullOption]="true"
                    [tipoClassificacaoCadastroCliente]="true"
                    defaultTitle="Classificações"
                    [disabled]="!isFilterInitialized">
                </sgt-classificacao-tipo-multiselect>                
            </div>
            <!-- Temperaturas -->
            <div class="lead-filter-quick-block-multiselect-item">
                <sgt-temperatura-multiselect
                    [(temperaturas)]="filter.temperaturas"
                    (temperaturasChange)="onChangeTemperaturasLead()"
                    defaultTitle="Temperaturas"
                    [disabled]="!isFilterInitialized">
                </sgt-temperatura-multiselect>
            </div>
        </div>

        <div class="lead-filter-quick-block lead-filter-quick-block-filter-psq">
            <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar...">
        </div>        

        <div class="lead-filter-quick-block lead-filter-quick-block-options">
            <div class="lead-filter-quick-block-options-btns">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-sync"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
    
                    <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                        (click)="toggleCollapse()" title="Filtro avançado"
                        [disabled]="!isFilterInitialized">
                        <ng-template [ngIf]="isFilterInitialized">
                            <i class="fas fa-filter" aria-hidden="true"></i>
                            <i [class]="collapseIcon" aria-hidden="true"></i>
                        </ng-template>
                        <ng-template [ngIf]="isFilterInitializing">
                            <i class='fas fa-spinner fa-pulse'></i>
                        </ng-template>
                    </button>
                </div>  
            </div>
        </div>
    </div>

    
    <div class="lead-filter-collapse" #filterCollapse>
        <div class="row">
            <div class="form-group col-md">
                <label class="col-form-label">Tipo</label>
                <sgt-pessoa-tipo-multiselect
                    [(tipos)]="filter.tiposPessoas"
                    (tiposChange)="filter.isFilterDirty = true;">
                </sgt-pessoa-tipo-multiselect>
            </div>                       
            <div class="form-group col-12 col-md">
                <label for="filterCnpjCpf" class="col-form-label">CNPJ/CPF</label>
                <input type="text" class="form-control" [(ngModel)]="filter.cnpjCpf" name="filterCnpjCpf" id="filterCnpjCpf"
                    (ngModelChange)="filter.isFilterDirty = true;">
            </div>            
            <div class="form-group col-12 col-md">
                <label for="filterEmail" class="col-form-label">E-mail</label>
                <input type="mail" class="form-control" [(ngModel)]="filter.email" name="filterEmail" id="filterEmail"
                    (ngModelChange)="filter.isFilterDirty = true;">
            </div> 
            <div class="form-group col-12 col-md">
                <label for="filterTelefoneCelular" class="col-form-label">Telefone/Celular</label>
                <input type="mail" class="form-control" [(ngModel)]="filter.telefoneCelular" name="filterTelefoneCelular" id="filterTelefoneCelular"
                    (ngModelChange)="filter.isFilterDirty = true;">
            </div>                                                                                 
        </div> 

        <div class="row">
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Canais de Venda de Origem</label>
                <sgt-canal-venda-multiselect
                    [(idsCanaisVendas)]="filter.idsCanaisVendaOrigem"
                    (idsCanaisVendasChange)="filter.isFilterDirty = true">
                </sgt-canal-venda-multiselect>
                <p class="form-text text-muted">Canais de Venda de origem dos leads</p>
            </div>

            <div class="form-group col-12 col-md">
                <label class="col-form-label">Canais de Mídias Sociais</label>
                <sgt-canal-midia-social-multiselect
                    [(canaisMidiasSociais)]="filter.canaisMidiasSociais"
                    (canaisMidiasSociaisChange)="filter.isFilterDirty = true"
                    [(nullOption)]="filter.canalMidiaSocialNull"
                    [showNullOption]="true">
                </sgt-canal-midia-social-multiselect>          
                <p class="form-text text-muted">Canais de Mídias Sociais de origem dos leads</p>            
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Campanhas Origens</label>
                <sgt-campanha-multiselect
                    [(idsCampanhas)]="filter.idsCampanhasOrigens"
                    (idsCampanhasChange)="onChangeCampanhasOrigens()"
                    [(nullOption)]="filter.campanhaOrigemNull"
                    [showNullOption]="true"
                    [(somenteEmAndamento)]="filter.somenteCampanhasQualificacaoEmAndamento"
                    [objetivoAquisicao]="true"
                    defaultTitle="Campanhas">
                </sgt-campanha-multiselect>   
                <p class="form-text text-muted">Campanhas de origem dos leads</p>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-md-3">
                <label for="dataCadastroInicial" class="col-form-label">Cadastro Inicial</label>
                <sgt-datepicker [(ngModel)]="filter.dataCadastroInicial" name="dataCadastroInicial" id="dataCadastroInicial"
                    #dataCadastroInicial="ngModel" [ngControl]="dataCadastroInicial" (ngModelChange)="onChangeDataCadastro($event)">
                </sgt-datepicker>                        
            </div>
            <div class="form-group col-12 col-md-3">
                <label for="dataCadastroFinal" class="col-form-label">Cadastro Final</label>
                <sgt-datepicker [(ngModel)]="filter.dataCadastroFinal" name="dataCadastroFinal" id="dataCadastroFinal"
                    #dataCadastroFinal="ngModel" [ngControl]="dataCadastroFinal" (ngModelChange)="onChangeDataCadastro($event)">
                </sgt-datepicker>                        
            </div>    
        </div>  
        
        <div class="row">
            <div class="form-group col-12 col-md-6 col-xl">
                <label for="filterRegiao" class="col-form-label">Região</label>
                <sgt-regiao-multiselect
                    [(idsRegioes)]="filter.idsRegioes"
                    (idsRegioesChange)="filter.isFilterDirty = true;"
                    [(nullOption)]="filter.regiaoNull"
                    [(somenteAtivas)]="filter.somenteRegioesAtivas"
                    nameSomenteAtivas="filterRegiaoSomenteAtivas"
                    idSomenteAtivas="filterRegiaoSomenteAtivas">
                </sgt-regiao-multiselect>
            </div>             
            <div class="form-group col-12 col-md-6 col-xl">
                <label class="col-form-label">Estados</label>
                <sgt-estado-multiselect
                    [(idsEstados)]="filter.idsEstados"
                    (idsEstadosChange)="onChangeEstados()"
                    [disabled]="!isFilterInitialized">
                </sgt-estado-multiselect>
            </div>
            <div class="form-group col-12 col-md-6 col-xl">
                <label for="filterCidade" class="col-form-label">Cidade</label>
                <sgt-typeahead-cidade [(ngModel)]="filter.cidade" name="filterCidade" id="filterCidade"
                    #filterCidade="ngModel" [ngControl]="filterCidade" [dropup]="true"
                    (entitySelected)="onSelectCidade($event)" (clearEntity)="onClearCidade()">
                </sgt-typeahead-cidade>
            </div>
            <ng-template [ngIf]="filter.cidade?.possuiSubRegioes">
                <div class="form-group col-12 col-md">
                    <label for="filterCidadesSubRegioes" class="col-form-label">Sub-Regiões</label>
                    <ngx-bootstrap-multiselect
                        [settings]="multiselectCidadesSubRegioesSettings"
                        [texts]="multiselectCidadesSubRegioesTexts"
                        [options]="multiselectCidadesSubRegioesOptions"
                        [(ngModel)]="filter.idsCidadesSubRegioes"
                        (ngModelChange)="onChangeCidadesSubRegioes()">
                    </ngx-bootstrap-multiselect>
                </div>
                <div class="form-group col-12 col-md">
                    <label for="filterCidadesSubRegioesBairros" class="col-form-label">Bairros</label>
                    <ngx-bootstrap-multiselect
                        [settings]="multiselectCidadesSubRegioesBairrosSettings"
                        [texts]="multiselectCidadesSubRegioesBairrosTexts"
                        [options]="multiselectCidadesSubRegioesBairrosOptions"
                        [(ngModel)]="filter.idsCidadesSubRegioesBairros"
                        (ngModelChange)="onChangeCidadesSubRegioesBairros()">
                    </ngx-bootstrap-multiselect>
                </div>
            </ng-template>            
        </div>       
    </div>
</div>

